// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"uploadTags_searchButton__1IchJ"};